import { Authentication } from "@leedpulse-monorepo/classes";
import HttpClient from "../../../core/HttpClient";

export const sendStartEmail = async (
  emails: string[],
  aiName: string,
  auth: Authentication,
  apiKey: string
): Promise<void> => {
  try {
    await HttpClient.post(
      "/subscription/emails/startcontract",
      { emails, aiName },
      auth.token,
      false,
      { 'x-api-key': apiKey }
    );
  } catch (error) {
    console.error("❌ Erreur lors de l'envoi de l'email :", error);
    throw error;
  }
};
